export function initAoxInViewport({
	element,
	onEnter,
	onLeave = null,
	threshold = 0.2,
	rootMargin = '0px 0px -80px 0px',
	once = true
}) {
	if (!element || typeof IntersectionObserver === 'undefined') {
		return null
	}

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					if (typeof onEnter === 'function') {
						onEnter(entry)
					}

					if (once) {
						observer.unobserve(entry.target)
					}
				} else if (!once && typeof onLeave === 'function') {
					onLeave(entry)
				}
			})
		},
		{
			threshold,
			rootMargin
		}
	)

	observer.observe(element)

	return observer
}

export function destroyAoxInViewport(observer) {
	if (observer && typeof observer.disconnect === 'function') {
		observer.disconnect()
	}
}